import { useLocalization } from '@/services/localizationService';
import { RefObject, useCallback, useRef } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { pushModalSelector } from '@/stores/modalStore';
import { authState } from '@/stores/authStore';
import { UserAction } from '@/services/userService';
import { OnboardingModal } from '@/layout/menuActions';

export const useMediaUnreachable = () => {
  const { t, data } = useLocalization();
  const auth = useRecoilValue(authState);
  const pushModal = useSetRecoilState(pushModalSelector);
  const loginReturnRef = useRef<HTMLButtonElement | HTMLAnchorElement>(null);
  const onLoginButtonClick = useCallback(
    () =>
      pushModal({
        id: 'result:onboard',
        Modal: OnboardingModal,
        previousAction: UserAction.Login,
        onClose: () => loginReturnRef.current?.focus(),
      }),
    [pushModal]
  );
  return {
    loginReturnRef,
    linkExpiredText: t(data.common.linkExpired),
    loginText: t(data.common.login),
    orText: t(data.common.or),
    returnToHomepageText: t(data.common.returnToHomepage),
    isLoginButtonVisible: auth.isGuestToken,
    returnToHomepageRef: auth.isGuestToken
      ? null
      : (loginReturnRef as RefObject<HTMLAnchorElement>),
    onLoginButtonClick,
  };
};
